"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_PHARMACY_MASTER_PERMISSIONS = exports.PharmacyMasterPermissions = void 0;
/**
 * Permission string catalog for `PackagingHierarchyTemplate` and
 * `VendorPharmacyProfile` only (Stage 14, Phase 1, Step 1b — ADR-030
 * decision 13). The pure-lookup sub-masters this step also adds
 * (PACKAGING_UNIT/KIT_TYPE/DRUG_SCHEDULE/STORAGE_CONDITION) need no new
 * permissions — already gated by existing LOOKUP_TYPE_MANAGE/
 * LOOKUP_VALUE_MANAGE.
 */
exports.PharmacyMasterPermissions = {
    PACKAGING_HIERARCHY_TEMPLATE_READ: 'packaging-hierarchy-template:read',
    PACKAGING_HIERARCHY_TEMPLATE_CREATE: 'packaging-hierarchy-template:create',
    PACKAGING_HIERARCHY_TEMPLATE_UPDATE: 'packaging-hierarchy-template:update',
    PACKAGING_HIERARCHY_TEMPLATE_DELETE: 'packaging-hierarchy-template:delete',
    PACKAGING_HIERARCHY_TEMPLATE_MANAGE: 'packaging-hierarchy-template:manage',
    PACKAGING_HIERARCHY_TEMPLATE_APPROVE: 'packaging-hierarchy-template:approve',
    VENDOR_PHARMACY_PROFILE_READ: 'vendor-pharmacy-profile:read',
    VENDOR_PHARMACY_PROFILE_CREATE: 'vendor-pharmacy-profile:create',
    VENDOR_PHARMACY_PROFILE_UPDATE: 'vendor-pharmacy-profile:update',
    VENDOR_PHARMACY_PROFILE_DELETE: 'vendor-pharmacy-profile:delete',
    VENDOR_PHARMACY_PROFILE_MANAGE: 'vendor-pharmacy-profile:manage',
};
exports.ALL_PHARMACY_MASTER_PERMISSIONS = Object.values(exports.PharmacyMasterPermissions);
//# sourceMappingURL=pharmacy-master.permissions.js.map